// src/components/ProjectDetailItem.tsx
import React from 'react';
import { Progress } from 'antd'; // Ant Design Progress for the bar

interface ProjectDetail {
    title: string;
    company: string;
    progress: number;
    dueDate: string;
    statusLabel: string;
    statusColor: 'success' | 'warning' | 'error';
}

const statusStyles: { [key: string]: string } = {
    success: 'bg-green-100 text-green-600',
    warning: 'bg-red-100 text-red-600', // Red in image, so mapping to warning/error color
    error: 'bg-orange-100 text-orange-600', // Orange/Yellow in image, so mapping to error color
};

const progressStatusMap: { [key: string]: 'normal' | 'exception' } = {
    success: 'normal',
    warning: 'exception',
    error: 'exception',
};

const ProjectDetailItem: React.FC<{ data: ProjectDetail }> = ({ data }) => {
    return (
        <div className="border-b last:border-b-0 py-4 px-6">
            <div className="flex justify-between items-start">
                <div className="flex flex-col">
                    <div className="font-semibold text-gray-800">{data.title}</div>
                    <div className="text-xs text-gray-500">{data.company}</div>
                </div>
                <div className={`text-xs font-medium px-2 py-0.5 rounded-full ${statusStyles[data.statusColor]}`}>
                    {data.statusLabel}
                </div>
            </div>
            <div className="mt-2">
                <Progress
                    percent={data.progress}
                    size="small"
                    status={progressStatusMap[data.statusColor]}
                    strokeColor={
                        data.statusColor === 'success'
                            ? '#52C41A' // Green
                            : data.statusColor === 'warning'
                                ? '#FF4D4F' // Red
                                : '#FAAD14' // Yellow/Orange
                    }
                    className="w-full"
                    showInfo={false}
                />
            </div>
            <div className="text-xs text-gray-500 mt-1">Due Date: {data.dueDate}</div>
        </div>
    );
};

export default ProjectDetailItem;